import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { sessionImpersonated, sessionLoggedOut } from '../../session/model/actions';

const STORAGE_KEY = 'organizationId';

interface OrganizationState {
  selectedId: string | null;
  isSwitching: boolean;
}

const initialState: OrganizationState = {
  selectedId: localStorage.getItem(STORAGE_KEY),
  isSwitching: false,
};

export const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    selectOrganization: (state, action: PayloadAction<string>) => {
      state.selectedId = action.payload;
      state.isSwitching = false;
      localStorage.setItem(STORAGE_KEY, action.payload);
    },
    openOrganizationSwitcher: (state) => {
      state.isSwitching = true;
    },
    closeOrganizationSwitcher: (state) => {
      state.isSwitching = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sessionLoggedOut, (state) => {
      state.selectedId = null;
      state.isSwitching = false;
      localStorage.removeItem(STORAGE_KEY);
    });

    builder.addCase(sessionImpersonated, (state) => {
      state.selectedId = null;
      state.isSwitching = false;
      localStorage.removeItem(STORAGE_KEY);
    });
  },
  selectors: {
    selectOrganizationId: (state) => state.selectedId ?? '',
    selectIsOrganizationChosen: (state) => state.selectedId !== null,
    selectIsSwitching: (state) => state.isSwitching,
  },
});

export const { selectOrganization, openOrganizationSwitcher, closeOrganizationSwitcher } =
  organizationSlice.actions;

export const { selectOrganizationId, selectIsOrganizationChosen, selectIsSwitching } =
  organizationSlice.selectors;

export const organizationReducer = organizationSlice.reducer;
